module.exports = __webpack_public_path__ + "img/dp-lc1-no2.0febc5cc.png";